import { productApi } from "src/services/api";
import { GetProductDto } from "src/services/generated-api";

export async function fetchProducts(): Promise<GetProductDto[]> {
  const response = await productApi.getManyBaseProductControllerProduct();
  return (response.data as { data: GetProductDto[] }).data;
}
